


















































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney } from '@/utils/common'
import ModalPlanosIncluir from './ModalPlanosIncluir.vue'

@Component({
  components: {
    ModalPlanosIncluir,
  },
})
export default class PlanoDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentos: boolean = false
  get loadingProcedimentos() { return this.loadProcedimentos }
  set loadingProcedimentos(value: boolean) { this.loadProcedimentos = value }

  get procedimentosHeader() {
    return [
      { text: 'Incluído por', value: 'createdByNome', sortable: false, align: 'center' },
      { text: 'Incluído em', value: 'createdOn', sortable: false, align: 'center' },
      { text: 'Código HIS', value: 'codigoHis', sortable: false, align: 'center' },
      { text: 'Nome plano HIS', value: 'nomePlanoHis', sortable: false, align: 'center' },
      { text: 'Fator plano', value: 'fatorPlano', sortable: false, align: 'center' },
      { text: 'Abrangência', value: 'abrangencia', sortable: false, align: 'center' },
      { text: 'Ações', value: '', sortable: false, align: 'center' },
    ]
  }

  get planos() { return this.getRegrasDeCalculoStore.planos }
  get paginacaoPlano() { return this.getRegrasDeCalculoStore.paginacaoPlanos }
  planoDebounce = _.debounce(param => this.getRegrasDeCalculoStore.getPlanoAll(param), 700)

  async updatePaginationPlano(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingProcedimentos = true
    this.planoDebounce(pagination)
    this.loadingProcedimentos = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatMoneyUtil(value: any) {
    return maskMoney(value)
  }

  loadDeletarPlano: string = ''
  get loadingDeletarPlano() { return this.loadDeletarPlano }
  set loadingDeletarPlano(value: string) { this.loadDeletarPlano = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.plano }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'plano', value }) }

  async removePlano(planoId: string) {
    this.loadingDeletarPlano = planoId
    const request = await this.getRegrasDeCalculoStore.removePlano(planoId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarPlano = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarPlano = ''
  }
}
